import { Moment, Duration } from 'moment';

import { ItemOrderHistoryBase } from 'app/buffer-graph/models/item-order-history/item-order-history-base';

export class ItemOrderHistoryFresh extends ItemOrderHistoryBase<ItemOrderHistoryFresh> {
    constructor(
        orderId: number,
        date: Moment,
        planArriveDate: Moment,
        order: number,
        status: number,
        statusDescr: string,
        fulfillment: number,
        fulfillmentDescr: string,
        arrivalDate: Moment,
        arrivedQuantity: number,
        supplierCode: string,
        supplierName: string,
        buffer: number,
        safetyStock: number,
        balance: number,
        inTransit: number,
        need: number,
        hasData: string,
        hasMoq: string,
        hasMoa: string,
        public readonly nextInputDate: Moment,
        public readonly orderTime: Duration,
        public readonly deliveryTime: Duration,
        public readonly lifeTime: number,
        public readonly weekSale: number,
        public readonly lastWeekSale: number,
        public readonly changedCoeff: number,
        public readonly baseBuffer: number,
        public readonly actionQnt: number,
        public readonly newMover: string,
        public readonly hasHolidayQnt: string,
        isCwh: boolean,
        crossDock: ItemOrderHistoryFresh) {
        super(orderId,
            date,
            planArriveDate,
            order,
            status,
            statusDescr,
            fulfillment,
            fulfillmentDescr,
            arrivalDate,
            arrivedQuantity,
            supplierCode,
            supplierName,
            buffer,
            safetyStock,
            balance,
            inTransit,
            need,
            hasData,
            hasMoq,
            hasMoa,
            isCwh,
            crossDock);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history-fresh.ts